/**
 * HeroData.js
 * 
 * This module provides data for all Dota 2 heroes.
 * For a production application, this would be fetched from an API.
 */

// Hero data with common heroes for demonstration
export const HeroData = {
  abaddon: {
    id: 'abaddon',
    name: 'Abaddon',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/abaddon.png',
    attributes: { primary: 'str', str: 23, agi: 17, int: 21 }
  },
  alchemist: {
    id: 'alchemist',
    name: 'Alchemist',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/alchemist.png',
    attributes: { primary: 'str', str: 25, agi: 16, int: 25 }
  },
  ancient_apparition: {
    id: 'ancient_apparition',
    name: 'Ancient Apparition',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/ancient_apparition.png',
    attributes: { primary: 'int', str: 20, agi: 20, int: 23 }
  },
  antimage: {
    id: 'antimage',
    name: 'Anti-Mage',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/antimage.png',
    attributes: { primary: 'agi', str: 19, agi: 24, int: 12 }
  },
  arc_warden: {
    id: 'arc_warden',
    name: 'Arc Warden',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/arc_warden.png',
    attributes: { primary: 'agi', str: 22, agi: 20, int: 24 }
  },
  axe: {
    id: 'axe',
    name: 'Axe',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/axe.png',
    attributes: { primary: 'str', str: 25, agi: 20, int: 18 }
  },
  bane: {
    id: 'bane',
    name: 'Bane',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/bane.png',
    attributes: { primary: 'int', str: 22, agi: 22, int: 22 }
  },
  batrider: {
    id: 'batrider',
    name: 'Batrider',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/batrider.png',
    attributes: { primary: 'int', str: 23, agi: 15, int: 24 }
  },
  beastmaster: {
    id: 'beastmaster',
    name: 'Beastmaster',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/beastmaster.png',
    attributes: { primary: 'str', str: 23, agi: 18, int: 16 }
  },
  bloodseeker: {
    id: 'bloodseeker',
    name: 'Bloodseeker',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/bloodseeker.png',
    attributes: { primary: 'agi', str: 24, agi: 24, int: 18 }
  },
  bounty_hunter: {
    id: 'bounty_hunter',
    name: 'Bounty Hunter',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/bounty_hunter.png',
    attributes: { primary: 'agi', str: 20, agi: 21, int: 19 }
  },
  brewmaster: {
    id: 'brewmaster',
    name: 'Brewmaster',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/brewmaster.png',
    attributes: { primary: 'str', str: 23, agi: 19, int: 15 }
  },
  bristleback: {
    id: 'bristleback',
    name: 'Bristleback',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/bristleback.png',
    attributes: { primary: 'str', str: 22, agi: 17, int: 14 }
  },
  broodmother: {
    id: 'broodmother',
    name: 'Broodmother',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/broodmother.png',
    attributes: { primary: 'agi', str: 18, agi: 19, int: 18 }
  },
  centaur: {
    id: 'centaur',
    name: 'Centaur Warrunner',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/centaur.png',
    attributes: { primary: 'str', str: 27, agi: 15, int: 15 }
  },
  chaos_knight: {
    id: 'chaos_knight',
    name: 'Chaos Knight',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/chaos_knight.png',
    attributes: { primary: 'str', str: 22, agi: 18, int: 16 }
  },
  chen: {
    id: 'chen',
    name: 'Chen',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/chen.png',
    attributes: { primary: 'int', str: 25, agi: 15, int: 19 }
  },
  clinkz: {
    id: 'clinkz',
    name: 'Clinkz',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/clinkz.png',
    attributes: { primary: 'agi', str: 16, agi: 22, int: 18 }
  },
  crystal_maiden: {
    id: 'crystal_maiden',
    name: 'Crystal Maiden',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/crystal_maiden.png',
    attributes: { primary: 'int', str: 17, agi: 16, int: 16 }
  },
  dark_seer: {
    id: 'dark_seer',
    name: 'Dark Seer',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/dark_seer.png',
    attributes: { primary: 'int', str: 22, agi: 19, int: 21 }
  },
  dark_willow: {
    id: 'dark_willow',
    name: 'Dark Willow',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/dark_willow.png',
    attributes: { primary: 'int', str: 20, agi: 21, int: 23 }
  },
  dawnbreaker: {
    id: 'dawnbreaker',
    name: 'Dawnbreaker',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/dawnbreaker.png',
    attributes: { primary: 'str', str: 24, agi: 16, int: 21 }
  },
  dazzle: {
    id: 'dazzle',
    name: 'Dazzle',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/dazzle.png',
    attributes: { primary: 'int', str: 19, agi: 21, int: 22 }
  },
  death_prophet: {
    id: 'death_prophet',
    name: 'Death Prophet',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/death_prophet.png',
    attributes: { primary: 'int', str: 19, agi: 14, int: 25 }
  },
  disruptor: {
    id: 'disruptor',
    name: 'Disruptor',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/disruptor.png',
    attributes: { primary: 'int', str: 21, agi: 15, int: 22 }
  },
  doom_bringer: {
    id: 'doom_bringer',
    name: 'Doom',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/doom_bringer.png',
    attributes: { primary: 'str', str: 24, agi: 15, int: 15 }
  },
  dragon_knight: {
    id: 'dragon_knight',
    name: 'Dragon Knight',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/dragon_knight.png',
    attributes: { primary: 'str', str: 21, agi: 16, int: 18 }
  },
  drow_ranger: {
    id: 'drow_ranger',
    name: 'Drow Ranger',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/drow_ranger.png',
    attributes: { primary: 'agi', str: 16, agi: 20, int: 15 }
  },
  earth_spirit: {
    id: 'earth_spirit',
    name: 'Earth Spirit',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/earth_spirit.png',
    attributes: { primary: 'str', str: 21, agi: 17, int: 20 }
  },
  earthshaker: {
    id: 'earthshaker',
    name: 'Earthshaker',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/earthshaker.png',
    attributes: { primary: 'str', str: 22, agi: 12, int: 16 }
  },
  elder_titan: {
    id: 'elder_titan',
    name: 'Elder Titan',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/elder_titan.png',
    attributes: { primary: 'str', str: 24, agi: 14, int: 24 }
  },
  ember_spirit: {
    id: 'ember_spirit',
    name: 'Ember Spirit',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/ember_spirit.png',
    attributes: { primary: 'agi', str: 22, agi: 22, int: 20 }
  },
  enchantress: {
    id: 'enchantress',
    name: 'Enchantress',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/enchantress.png',
    attributes: { primary: 'int', str: 19, agi: 19, int: 22 }
  },
  enigma: {
    id: 'enigma',
    name: 'Enigma',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/enigma.png',
    attributes: { primary: 'int', str: 21, agi: 14, int: 21 }
  },
  faceless_void: {
    id: 'faceless_void',
    name: 'Faceless Void',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/faceless_void.png',
    attributes: { primary: 'agi', str: 19, agi: 19, int: 15 }
  },
  grimstroke: {
    id: 'grimstroke',
    name: 'Grimstroke',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/grimstroke.png',
    attributes: { primary: 'int', str: 21, agi: 18, int: 23 }
  },
  gyrocopter: {
    id: 'gyrocopter',
    name: 'Gyrocopter',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/gyrocopter.png',
    attributes: { primary: 'agi', str: 18, agi: 24, int: 19 }
  },
  hoodwink: {
    id: 'hoodwink',
    name: 'Hoodwink',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/hoodwink.png',
    attributes: { primary: 'agi', str: 17, agi: 24, int: 21 }
  },
  huskar: {
    id: 'huskar',
    name: 'Huskar',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/huskar.png',
    attributes: { primary: 'str', str: 21, agi: 15, int: 18 }
  },
  invoker: {
    id: 'invoker',
    name: 'Invoker',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/invoker.png',
    attributes: { primary: 'int', str: 19, agi: 14, int: 15 }
  },
  io: {
    id: 'io',
    name: 'Io',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/wisp.png',
    attributes: { primary: 'str', str: 20, agi: 14, int: 23 }
  },
  jakiro: {
    id: 'jakiro',
    name: 'Jakiro',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/jakiro.png',
    attributes: { primary: 'int', str: 25, agi: 10, int: 26 }
  },
  juggernaut: {
    id: 'juggernaut',
    name: 'Juggernaut',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/juggernaut.png',
    attributes: { primary: 'agi', str: 20, agi: 26, int: 14 }
  },
  keeper_of_the_light: {
    id: 'keeper_of_the_light',
    name: 'Keeper of the Light',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/keeper_of_the_light.png',
    attributes: { primary: 'int', str: 16, agi: 15, int: 23 }
  },
  kunkka: {
    id: 'kunkka',
    name: 'Kunkka',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/kunkka.png',
    attributes: { primary: 'str', str: 24, agi: 14, int: 18 }
  },
  legion_commander: {
    id: 'legion_commander',
    name: 'Legion Commander',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/legion_commander.png',
    attributes: { primary: 'str', str: 25, agi: 18, int: 20 }
  },
  leshrac: {
    id: 'leshrac',
    name: 'Leshrac',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/leshrac.png',
    attributes: { primary: 'int', str: 18, agi: 23, int: 22 }
  },
  lich: {
    id: 'lich',
    name: 'Lich',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/lich.png',
    attributes: { primary: 'int', str: 20, agi: 17, int: 24 }
  },
  life_stealer: {
    id: 'life_stealer',
    name: 'Lifestealer',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/life_stealer.png',
    attributes: { primary: 'str', str: 25, agi: 19, int: 15 }
  },
  lina: {
    id: 'lina',
    name: 'Lina',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/lina.png',
    attributes: { primary: 'int', str: 20, agi: 23, int: 30 }
  },
  lion: {
    id: 'lion',
    name: 'Lion',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/lion.png',
    attributes: { primary: 'int', str: 18, agi: 15, int: 20 }
  },
  mirana: {
    id: 'mirana',
    name: 'Mirana',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/mirana.png',
    attributes: { primary: 'all', str: 18, agi: 18, int: 18 }
  },
  nevermore: {
    id: 'nevermore',
    name: 'Shadow Fiend',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/nevermore.png',
    attributes: { primary: 'agi', str: 19, agi: 20, int: 18 }
  },
  pudge: {
    id: 'pudge',
    name: 'Pudge',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/pudge.png',
    attributes: { primary: 'str', str: 25, agi: 14, int: 16 }
  },
  storm_spirit: {
    id: 'storm_spirit',
    name: 'Storm Spirit',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/storm_spirit.png',
    attributes: { primary: 'int', str: 21, agi: 22, int: 26 }
  },
  tidehunter: {
    id: 'tidehunter',
    name: 'Tidehunter',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/tidehunter.png',
    attributes: { primary: 'str', str: 27, agi: 15, int: 16 }
  },
  witch_doctor: {
    id: 'witch_doctor',
    name: 'Witch Doctor',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/witch_doctor.png',
    attributes: { primary: 'int', str: 18, agi: 13, int: 22 }
  },
  luna: {
    id: 'luna',
    name: 'Luna',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/luna.png',
    attributes: { primary: 'agi', str: 19, agi: 24, int: 18 }
  },
  lone_druid: {
    id: 'lone_druid',
    name: 'Lone Druid',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/lone_druid.png',
    attributes: { primary: 'agi', str: 22, agi: 17, int: 13 }
  },
  lycan: {
    id: 'lycan',
    name: 'Lycan',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/lycan.png',
    attributes: { primary: 'str', str: 24, agi: 16, int: 23 }
  },
  magnus: {
    id: 'magnus',
    name: 'Magnus',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/magnataur.png',
    attributes: { primary: 'str', str: 25, agi: 15, int: 19 }
  },
  marci: {
    id: 'marci',
    name: 'Marci',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/marci.png',
    attributes: { primary: 'str', str: 23, agi: 20, int: 19 }
  },
  mars: {
    id: 'mars',
    name: 'Mars',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/mars.png',
    attributes: { primary: 'str', str: 23, agi: 20, int: 21 }
  },
  medusa: {
    id: 'medusa',
    name: 'Medusa',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/medusa.png',
    attributes: { primary: 'agi', str: 15, agi: 22, int: 19 }
  },
  meepo: {
    id: 'meepo',
    name: 'Meepo',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/meepo.png',
    attributes: { primary: 'agi', str: 24, agi: 23, int: 20 }
  },
  monkey_king: {
    id: 'monkey_king',
    name: 'Monkey King',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/monkey_king.png',
    attributes: { primary: 'agi', str: 19, agi: 22, int: 20 }
  },
  morphling: {
    id: 'morphling',
    name: 'Morphling',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/morphling.png',
    attributes: { primary: 'agi', str: 22, agi: 24, int: 19 }
  },
  muerta: {
    id: 'muerta',
    name: 'Muerta',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/muerta.png',
    attributes: { primary: 'int', str: 16, agi: 20, int: 25 }
  },
  naga_siren: {
    id: 'naga_siren',
    name: 'Naga Siren',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/naga_siren.png',
    attributes: { primary: 'agi', str: 21, agi: 21, int: 21 }
  },
  natures_prophet: {
    id: 'natures_prophet',
    name: "Nature's Prophet",
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/furion.png',
    attributes: { primary: 'int', str: 19, agi: 18, int: 23 }
  },
  necrolyte: {
    id: 'necrolyte',
    name: 'Necrophos',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/necrolyte.png',
    attributes: { primary: 'int', str: 18, agi: 15, int: 21 }
  },
  night_stalker: {
    id: 'night_stalker',
    name: 'Night Stalker',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/night_stalker.png',
    attributes: { primary: 'str', str: 23, agi: 18, int: 15 }
  },
  nyx_assassin: {
    id: 'nyx_assassin',
    name: 'Nyx Assassin',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/nyx_assassin.png',
    attributes: { primary: 'agi', str: 18, agi: 19, int: 21 }
  },
  obsidian_destroyer: {
    id: 'obsidian_destroyer',
    name: 'Outworld Destroyer',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/obsidian_destroyer.png',
    attributes: { primary: 'int', str: 19, agi: 24, int: 30 }
  },
  ogre_magi: {
    id: 'ogre_magi',
    name: 'Ogre Magi',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/ogre_magi.png',
    attributes: { primary: 'str', str: 23, agi: 14, int: 20 }
  },
  omniknight: {
    id: 'omniknight',
    name: 'Omniknight',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/omniknight.png',
    attributes: { primary: 'str', str: 23, agi: 15, int: 16 }
  },
  oracle: {
    id: 'oracle',
    name: 'Oracle',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/oracle.png',
    attributes: { primary: 'int', str: 20, agi: 15, int: 23 }
  },
  phantom_assassin: {
    id: 'phantom_assassin',
    name: 'Phantom Assassin',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/phantom_assassin.png',
    attributes: { primary: 'agi', str: 19, agi: 23, int: 15 }
  },
  phantom_lancer: {
    id: 'phantom_lancer',
    name: 'Phantom Lancer',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/phantom_lancer.png',
    attributes: { primary: 'agi', str: 19, agi: 26, int: 21 }
  },
  phoenix: {
    id: 'phoenix',
    name: 'Phoenix',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/phoenix.png',
    attributes: { primary: 'str', str: 23, agi: 12, int: 16 }
  },
  primal_beast: {
    id: 'primal_beast',
    name: 'Primal Beast',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/primal_beast.png',
    attributes: { primary: 'str', str: 26, agi: 15, int: 16 }
  },
  puck: {
    id: 'puck',
    name: 'Puck',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/puck.png',
    attributes: { primary: 'int', str: 17, agi: 22, int: 23 }
  },
  pugna: {
    id: 'pugna',
    name: 'Pugna',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/pugna.png',
    attributes: { primary: 'int', str: 19, agi: 24, int: 24 }
  },
  queenofpain: {
    id: 'queenofpain',
    name: 'Queen of Pain',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/queenofpain.png',
    attributes: { primary: 'int', str: 18, agi: 22, int: 25 }
  },
  rattletrap: {
    id: 'rattletrap',
    name: 'Clockwerk',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/rattletrap.png',
    attributes: { primary: 'str', str: 27, agi: 13, int: 18 }
  },
  razor: {
    id: 'razor',
    name: 'Razor',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/razor.png',
    attributes: { primary: 'agi', str: 22, agi: 22, int: 21 }
  },
  riki: {
    id: 'riki',
    name: 'Riki',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/riki.png',
    attributes: { primary: 'agi', str: 17, agi: 34, int: 14 }
  },
  rubick: {
    id: 'rubick',
    name: 'Rubick',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/rubick.png',
    attributes: { primary: 'int', str: 21, agi: 23, int: 25 }
  },
  sand_king: {
    id: 'sand_king',
    name: 'Sand King',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/sand_king.png',
    attributes: { primary: 'str', str: 22, agi: 19, int: 19 }
  },
  shadow_demon: {
    id: 'shadow_demon',
    name: 'Shadow Demon',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/shadow_demon.png',
    attributes: { primary: 'int', str: 23, agi: 18, int: 25 }
  },
  shadow_shaman: {
    id: 'shadow_shaman',
    name: 'Shadow Shaman',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/shadow_shaman.png',
    attributes: { primary: 'int', str: 23, agi: 16, int: 21 }
  },
  silencer: {
    id: 'silencer',
    name: 'Silencer',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/silencer.png',
    attributes: { primary: 'int', str: 19, agi: 22, int: 25 }
  },
  skeleton_king: {
    id: 'skeleton_king',
    name: 'Wraith King',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/skeleton_king.png',
    attributes: { primary: 'str', str: 22, agi: 16, int: 18 }
  },
  skywrath_mage: {
    id: 'skywrath_mage',
    name: 'Skywrath Mage',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/skywrath_mage.png',
    attributes: { primary: 'int', str: 21, agi: 13, int: 27 }
  },
  slardar: {
    id: 'slardar',
    name: 'Slardar',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/slardar.png',
    attributes: { primary: 'str', str: 21, agi: 17, int: 15 }
  },
  slark: {
    id: 'slark',
    name: 'Slark',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/slark.png',
    attributes: { primary: 'agi', str: 20, agi: 21, int: 16 }
  },
  snapfire: {
    id: 'snapfire',
    name: 'Snapfire',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/snapfire.png',
    attributes: { primary: 'str', str: 20, agi: 16, int: 21 }
  },
  sniper: {
    id: 'sniper',
    name: 'Sniper',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/sniper.png',
    attributes: { primary: 'agi', str: 19, agi: 27, int: 15 }
  },
  spectre: {
    id: 'spectre',
    name: 'Spectre',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/spectre.png',
    attributes: { primary: 'agi', str: 23, agi: 23, int: 16 }
  },
  spirit_breaker: {
    id: 'spirit_breaker',
    name: 'Spirit Breaker',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/spirit_breaker.png',
    attributes: { primary: 'str', str: 26, agi: 17, int: 14 }
  },
  sven: {
    id: 'sven',
    name: 'Sven',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/sven.png',
    attributes: { primary: 'str', str: 22, agi: 21, int: 16 }
  },
  techies: {
    id: 'techies',
    name: 'Techies',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/techies.png',
    attributes: { primary: 'int', str: 19, agi: 14, int: 25 }
  },
  templar_assassin: {
    id: 'templar_assassin',
    name: 'Templar Assassin',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/templar_assassin.png',
    attributes: { primary: 'agi', str: 19, agi: 23, int: 20 }
  },
  terrorblade: {
    id: 'terrorblade',
    name: 'Terrorblade',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/terrorblade.png',
    attributes: { primary: 'agi', str: 16, agi: 22, int: 19 }
  },
  tinker: {
    id: 'tinker',
    name: 'Tinker',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/tinker.png',
    attributes: { primary: 'int', str: 19, agi: 13, int: 30 }
  },
  tiny: {
    id: 'tiny',
    name: 'Tiny',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/tiny.png',
    attributes: { primary: 'str', str: 26, agi: 0, int: 17 }
  },
  treant: {
    id: 'treant',
    name: 'Treant Protector',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/treant.png',
    attributes: { primary: 'str', str: 25, agi: 15, int: 20 }
  },
  troll_warlord: {
    id: 'troll_warlord',
    name: 'Troll Warlord',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/troll_warlord.png',
    attributes: { primary: 'agi', str: 21, agi: 21, int: 13 }
  },
  tusk: {
    id: 'tusk',
    name: 'Tusk',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/tusk.png',
    attributes: { primary: 'str', str: 23, agi: 23, int: 18 }
  },
  undying: {
    id: 'undying',
    name: 'Undying',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/undying.png',
    attributes: { primary: 'str', str: 22, agi: 10, int: 27 }
  },
  ursa: {
    id: 'ursa',
    name: 'Ursa',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/ursa.png',
    attributes: { primary: 'agi', str: 25, agi: 18, int: 16 }
  },
  vengefulspirit: {
    id: 'vengefulspirit',
    name: 'Vengeful Spirit',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/vengefulspirit.png',
    attributes: { primary: 'agi', str: 19, agi: 20, int: 19 }
  },
  venomancer: {
    id: 'venomancer',
    name: 'Venomancer',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/venomancer.png',
    attributes: { primary: 'int', str: 18, agi: 24, int: 19 }
  },
  viper: {
    id: 'viper',
    name: 'Viper',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/viper.png',
    attributes: { primary: 'agi', str: 21, agi: 21, int: 15 }
  },
  visage: {
    id: 'visage',
    name: 'Visage',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/visage.png',
    attributes: { primary: 'int', str: 22, agi: 11, int: 24 }
  },
  void_spirit: {
    id: 'void_spirit',
    name: 'Void Spirit',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/void_spirit.png',
    attributes: { primary: 'int', str: 22, agi: 19, int: 24 }
  },
  warlock: {
    id: 'warlock',
    name: 'Warlock',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/warlock.png',
    attributes: { primary: 'int', str: 24, agi: 10, int: 25 }
  },
  weaver: {
    id: 'weaver',
    name: 'Weaver',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/weaver.png',
    attributes: { primary: 'agi', str: 16, agi: 17, int: 20 }
  },
  windrunner: {
    id: 'windrunner',
    name: 'Windranger',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/windrunner.png',
    attributes: { primary: 'int', str: 18, agi: 17, int: 18 }
  },
  winter_wyvern: {
    id: 'winter_wyvern',
    name: 'Winter Wyvern',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/winter_wyvern.png',
    attributes: { primary: 'int', str: 26, agi: 16, int: 25 }
  },
  zuus: {
    id: 'zuus',
    name: 'Zeus',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/zuus.png',
    attributes: { primary: 'int', str: 19, agi: 11, int: 22 }
  },
  ringmaster: {
    id: 'ringmaster',
    name: 'Ringmaster',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/ringmaster.png',
    attributes: { primary: 'int', str: 18, agi: 16, int: 24 }
  },
  kez: {
    id: 'kez',
    name: 'Kez',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/kez.png',
    attributes: { primary: 'agi', str: 17, agi: 25, int: 19 }
  },
  pangolier: {
    id: 'pangolier',
    name: 'Pangolier',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/pangolier.png',
    attributes: { primary: 'agi', str: 17, agi: 18, int: 16 }
  },
  underlord: {
    id: 'underlord',
    name: 'Underlord',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/abyssal_underlord.png',
    attributes: { primary: 'str', str: 25, agi: 12, int: 17 }
  },
  shredder: {
    id: 'shredder',
    name: 'Timbersaw',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/shredder.png',
    attributes: { primary: 'str', str: 22, agi: 16, int: 21 }
  },
  largo: {
    id: 'largo',
    name: 'Largo',
    imageUrl: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/largo.png',
    attributes: { primary: 'int', str: 20, agi: 18, int: 24 }
  }
};

export default {
  HeroData,
  getHeroById: (id) => HeroData[id.toLowerCase()] || null,
  getHeroByName: (name) => {
    const heroId = Object.keys(HeroData).find(key =>
      HeroData[key].name.toLowerCase() === name.toLowerCase()
    );
    return heroId ? HeroData[heroId] : null;
  },
  getAllHeroNames: () => {
    // Remove duplicates by using a Set based on hero names
    const uniqueNames = new Set();
    Object.values(HeroData).forEach(hero => uniqueNames.add(hero.name));
    return Array.from(uniqueNames).sort();
  }
}; 